import AppModuleType from "@/services/App/AppModuleType.js"

// see details: "@/services/Input/DataCatalog.js"
export default {
  Button: {
    NewItem: AppModuleType.New.Name + " barang baru"
  }
}